import type { RecordingCountCondition } from "@repo/app-types/entities/filterConditions";
import { SimpleMenu } from "@repo/ui/Menu/simpleMenu";
import { SimpleMenuItem } from "@repo/ui/Menu/simpleMenuItem";
import { SimpleMenuPopover } from "@repo/ui/Menu/simpleMenuPopover";
import type { FC } from "react";
import { SubmenuTrigger } from "react-aria-components";

export interface RecordingCountFilterOptionProps {
  value: RecordingCountCondition | null;
  onChange: (newValue: RecordingCountCondition | null) => void;
}

export const RecordingCountFilterOption: FC<RecordingCountFilterOptionProps> = (
  props,
) => {
  if (props.value !== null) {
    return null;
  }

  return (
    <SubmenuTrigger>
      <SimpleMenuItem>Calls per customer interaction</SimpleMenuItem>

      <SimpleMenuPopover className="w-[140px]">
        <SimpleMenu aria-label="Filter by calls per customer interaction">
          <SimpleMenuItem
            onAction={() => props.onChange({ operator: "=", value: 1 })}
          >
            1 call
          </SimpleMenuItem>

          {[2, 5, 10, 20].map((count) => (
            <SimpleMenuItem
              key={count}
              onAction={() => props.onChange({ operator: ">=", value: count })}
            >
              {count}+ calls
            </SimpleMenuItem>
          ))}
        </SimpleMenu>
      </SimpleMenuPopover>
    </SubmenuTrigger>
  );
};
